import { PagesResultProps } from '@grapesjs/react';
import { RiCloseLine } from '@remixicon/react';

import { AgButton } from 'src/components/ui';

import { NEW_PAGE } from '../document-editor/plugins/documentStorage';

import { BTN_CLS, cx, MAIN_BORDER_COLOR } from './common';

export default function CustomPageManager({ pages, selected, add, select, remove }: PagesResultProps) {
  const addNewPage = () => {
    const nextIndex = pages.length + 1;
    add({ name: `New page ${nextIndex}`, component: NEW_PAGE });
  };

  return (
    <div className="gjs-custom-page-manager">
      <div className="p-2">
        <button type="button" className={BTN_CLS} onClick={addNewPage}>
          Add new page
        </button>
      </div>
      {pages.map((page, index) => (
        <div
          key={page.getId()}
          className={cx('flex items-center py-2 px-1 border-b', index === 0 && 'border-t', MAIN_BORDER_COLOR)}
        >
          <button type="button" className="grow text-left" onClick={() => select(page)}>
            {page.getName() || 'Untitled page'}
          </button>
          {selected !== page && (
            <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => remove(page)}>
              <RiCloseLine size={20} />
            </AgButton>
          )}
        </div>
      ))}
    </div>
  );
}
